import { Box, Button, Toolbar, IconButton, TextField, InputAdornment, Typography, useTheme } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
import Tree from '../Tree/Tree';
import React, { useCallback, useEffect, useRef } from 'react';
import axiosInstance from '../../axios/axios';
import { END_POINTS } from '../../shared';
import { toast } from 'react-toastify';
import { createRegionFilterData, ITypeData, removeIndeterMinateProps, selectedFilterList } from '../../modules/authentication/shared/utils';
import _ from 'lodash';
import AssetsTree from '../AssetsTree/AssetsTree';
import { SkeletonLoader } from '../../modules/dashboard/shared';
import eventEmitter from '../utils/eventEmitter';

const GlobalFilter = ({ toggleGlobalFilter, setIsLoader, skipApiCall = false, onFilterDataSaved, preSelectedAssetIds = [], clearFilters = false, hideCloud = false }: any) => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [typeData, setTypeData] = React.useState<any>([]);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const [typeLoader, setTypeLoader] = React.useState(false);
  const [assetsLoader, setAssetsLoader] = React.useState(false);
  const [backUptypeData, setbackUptypeData] = React.useState([]);
  const [filterTypeData, setFilterTypeData] = React.useState([]);
  const [assetsData, setAssetsData] = React.useState([]);
  const [filterAssetsData, setfilterAssetsData] = React.useState<any[]>([]);
  const [selectedAssets, setselectedAssets] = React.useState<Set<any>>(new Set());
  const childRef = useRef<any>(null);
  const assetsTreeRef = useRef<any>(null);

  // const updateAfterClear = () => {
  //   if (childRef.current) {
  //     childRef.current.triggerClear();
  //   }
  // };
  // const updateAfterReset = () => {
  //   if (childRef.current) {
  //     childRef.current.triggerReset()
  //   }
  // };
  const getTypesData = useCallback(async () => {
    try {
      setTypeLoader(true);
      const response = await axiosInstance.get<any>(`${END_POINTS.GLOBAL_DASHBOARD_REGION}`);
      getTypesDataCallback(response.data);
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  }, []);
  const findNodeByType = (nodes: any[], type: string): any => {
    if (!Array.isArray(nodes)) return undefined;
    for (const node of nodes) {
      if (node.type === type) return node;
      if (node.data) {
        const found = findNodeByType(node.data, type);
        if (found) return found;
      }
    }
    return undefined;
  };

  // Finds all nodes matching a type and merges their data into a single virtual node
  const findAllNodesByType = (nodes: any[], type: string): any => {
    const results: any[] = [];
    const collect = (items: any[]) => {
      if (!Array.isArray(items)) return;
      for (const node of items) {
        if (node.type === type) results.push(node);
        if (node.data) collect(node.data);
      }
    };
    collect(nodes);
    if (results.length === 0) return undefined;
    if (results.length === 1) return results[0];
    // Merge all matching nodes into one virtual node
    const allSelected = results.every((n: any) => n.selected);
    const someSelected = results.some((n: any) => n.selected);
    return {
      ...results[0],
      id: results.map((n: any) => n.id).join('_'),
      selected: allSelected,
      indeterminate: !allSelected && someSelected,
      data: results.flatMap((n: any) => n.data || [])
    };
  };

  const getTypesDataCallback = (response: any) => {
    setTypeLoader(false);
    console.log('GLOBAL_DASHBOARD_REGION response:', response?.data);
    if (response && response.status === 200) {
      if (response.data.regions_list && response.data.regions_list.length) {
        response.data.regions_list[0].id = 'rl';
        response.data.regions_list[0].label = 'Region';
      }
      if (response.data.category_list && response.data.category_list.length) {
        response.data.category_list[0].id = 'cl';
      }
      if (response.data.vendor_list && response.data.vendor_list.length) {
        response.data.vendor_list[0].id = 'vl';
      }
       if (response.data.model_list && response.data.model_list.length) {
        response.data.model_list[0].id = 'ml';
      }
       if (response.data.cloud_accounts_list && response.data.cloud_accounts_list.length) {
        response.data.cloud_accounts_list[0].id = 'cla';
      }
       if (response.data.cloud_resource_types_list && response.data.cloud_resource_types_list.length) {
        response.data.cloud_resource_types_list[0].id = 'clrt';
      } if (response.data.cloud_regions_list && response.data.cloud_regions_list.length) {
        response.data.cloud_regions_list[0].id = 'clr';
      }

      // Split vendors by origin into onprem and cloud
      const allVendors = response.data.vendor_list && response.data.vendor_list.length
        ? response.data.vendor_list[0].data || []
        : [];
      const onpremVendors = allVendors.filter((v: any) => v.origin === 'onprem');
      const cloudVendors = allVendors.filter((v: any) => v.origin === 'cloud');

      const onpremVendorNode: any = {
        id: 'vl_onprem',
        label: 'Vendors',
        type: 'Vendors',
        parentid: null,
        indeterminate: false,
        selected: false,
        data: onpremVendors
      };

      const cloudVendorNode: any = {
        id: 'vl_cloud',
        label: 'Vendors',
        type: 'Vendors',
        parentid: null,
        indeterminate: false,
        selected: false,
        data: cloudVendors
      };

      const onpremNode: any = {
        id: 'onprem',
        label: 'On-Prem',
        type: 'onprem',
        data: []
      };
      if (onpremVendors.length) {
        onpremNode.data.push(onpremVendorNode);
      }
      if (response.data.regions_list && response.data.regions_list.length) {
        onpremNode.data.push(response.data.regions_list[0]);
      }
      if (response.data.category_list && response.data.category_list.length) {
        onpremNode.data.push(response.data.category_list[0]);
      }
      if (response.data.model_list && response.data.model_list.length) {
        onpremNode.data.push(response.data.model_list[0]);
      }

      const cloudNode: any = {
        id: 'cloud',
        label: 'Cloud',
        type: 'cloud',
        data: []
      };
      if (cloudVendors.length) {
        cloudNode.data.push(cloudVendorNode);
      }
      if (response.data.cloud_accounts_list && response.data.cloud_accounts_list.length) {
        cloudNode.data.push(response.data.cloud_accounts_list[0]);
      }
      if (response.data.cloud_regions_list && response.data.cloud_regions_list.length) {
        cloudNode.data.push(response.data.cloud_regions_list[0]);
      }
      if (response.data.cloud_resource_types_list && response.data.cloud_resource_types_list.length) {
        cloudNode.data.push(response.data.cloud_resource_types_list[0]);
      }

      const finalData: any = [];
      finalData.push(onpremNode);
      if (!hideCloud) {
        finalData.push(cloudNode);
      }

      const checked = new Set();
      const indeterminate = new Set();
      const initializeCheckedState = (node: any) => {
        if (node?.selected) checked.add(node.id);
        if (node?.data?.length > 0) {
          node.data.forEach(initializeCheckedState);
          const allChecked = node.data.length > 0 && node.data.every((child: any) => checked.has(child.id));
          const someChecked = node.data.some((child: any) => checked.has(child.id));
          const someIndeterminate = node.data.some((child: any) => indeterminate.has(child.id));
          
          if (allChecked) {
            checked.add(node.id);
            indeterminate.delete(node.id);
          } else if (someChecked || someIndeterminate) {
            indeterminate.add(node.id);
            checked.delete(node.id);
          } else {
            indeterminate.delete(node.id);
            checked.delete(node.id);
          }
        }
      };
      finalData.forEach(initializeCheckedState);

      const applyTreeState = (nodes: any[]) => {
        nodes.forEach(node => {
          node.selected = checked.has(node.id);
          node.indeterminate = indeterminate.has(node.id);
          if (node.data) applyTreeState(node.data);
        });
      };
      applyTreeState(finalData);

      setTypeData(_.cloneDeep(finalData));
      setbackUptypeData(_.cloneDeep(finalData));
      getAssetsData(_.cloneDeep(selectedFilterList(finalData)), finalData);
    }
  }

  const removeEmptyDataArrays = (arr: any[]) => {
    return arr.map(item => {
      if (Array.isArray(item.data)) {
        item.data = removeEmptyDataArrays(item.data);
        if (item.data.length === 0) {
          delete item.data;
        }
      }
      return item;
    });
  }

  const getAssetsData = useCallback(async (values: ITypeData[], fullTree?: ITypeData[]) => {
    setAssetsLoader(true);
    const filterRegionData: ITypeData | undefined = findNodeByType(values, 'Region') || findNodeByType(values, 'Regions');
    const filterAccountsData: ITypeData | undefined = findNodeByType(values, 'Account') || findNodeByType(values, 'Accounts');
    const filterResourceTypeData: ITypeData | undefined = findNodeByType(values, 'Resource Type') || findNodeByType(values, 'Resource Types');
    const filterCloudRegionData: ITypeData | undefined = findNodeByType(values, 'Cloud Region') || findNodeByType(values, 'Cloud Regions');
    const filterVendorData: ITypeData | undefined = findAllNodesByType(values, 'Vendors') || findAllNodesByType(values, 'Vendor');
    const filterCatData: ITypeData | undefined = findNodeByType(values, 'Asset Type') || findNodeByType(values, 'Asset Types');
    const filterModelData: ITypeData | undefined = findNodeByType(values, 'Model') || findNodeByType(values, 'Models');
    const regionFilter = filterRegionData ? createRegionFilterData(filterRegionData.data) : [];
    const cleanedRegionData = removeEmptyDataArrays(regionFilter);
    const cloudRegionFilter = filterCloudRegionData ? createRegionFilterData(filterCloudRegionData.data) : [];
    const cleanedCloudRegionData = removeEmptyDataArrays(cloudRegionFilter);
    const accountFilter = filterAccountsData ? createRegionFilterData(filterAccountsData.data) : [];
    const cleanedAccountData = removeEmptyDataArrays(accountFilter);
    const resourceTypeFilter = filterResourceTypeData ? createRegionFilterData(filterResourceTypeData.data) : [];
    const cleanedResourceTypeData = removeEmptyDataArrays(resourceTypeFilter);
    const checkAllSelected = (nodes: any[]): boolean => {
      return nodes.every((node) => {
        if (!node.selected) return false;
        if (node.data && node.data.length > 0) {
          return checkAllSelected(node.data);
        }
        return true;
      });
    };
    const isAllTypeSelected = fullTree && fullTree.length > 0 ? checkAllSelected(fullTree) : false;

    const req: any = {};
    
    if (!isAllTypeSelected) {
      const rList = cleanedRegionData || [];
      req.regions_list = rList.length ? rList : [];

      const vList = _.map(filterVendorData?.data, 'id');
      req.vendor_list = vList.length ? vList : [];

      const cList = _.map(filterCatData?.data, 'id');
      req.category_list = cList.length ? cList : [];

      const caList = _.map(filterAccountsData?.data, 'id') || [];
      req.cloud_accounts_list = caList.length ? caList : [];

      const crtList = _.map(filterResourceTypeData?.data, 'id') || [];
      req.cloud_resource_types_list = crtList.length ? crtList : [];

      const crList = cleanedCloudRegionData || [];
      req.cloud_regions_list = crList.length ? crList : [];

      const mList = _.map(filterModelData?.data, 'id');
      req.model_list = mList.length ? mList : [];
    } else {
      req.regions_list = [];
      req.vendor_list = [];
      req.category_list = [];
      req.model_list = [];
      req.cloud_accounts_list = [];
      req.cloud_resource_types_list = [];
      req.cloud_regions_list = [];
    }
    if (hideCloud) {
      req.module = "on_premise";
    }

    console.log('=== GET ASSETS DATA PAYLOAD ===');
    console.log('Payload sent to /api/securityscan/global-filter-device-list:', JSON.parse(JSON.stringify(req)));
    console.log('===============================');
    try {
      const response = await axiosInstance.post<any>(`${END_POINTS.GLOBAL_DASHBOARD_DEVICE}`, req);
      getAssetsDataCallback(response);
    } catch (error: any) {
      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  }, [hideCloud]);
  const getAssetsDataCallback = (response: any) => {
    setAssetsLoader(false);
    if (response && response.status === 200 && response.data.data.devices_list) {
      if (response.data.data.devices_list?.length) {
        removeIndeterMinateProps(response.data.data.devices_list);
      }
      let uniqueDevices = response.data.data.devices_list.filter(
        (device: any, index: number, self: any[]) =>
          self.findIndex((d) => d.id === device.id) === index
      );
      
      if (hideCloud) {
        uniqueDevices = uniqueDevices.filter((d: any) => 
          d.origin !== 'cloud' && 
          d.type !== 'cloud' &&
          d.device_type?.toLowerCase() !== 'cloud' && 
          !d.cloud_provider &&
          d.vendor?.toLowerCase() !== 'amazon web services' &&
          d.vendor?.toLowerCase() !== 'aws' &&
          d.vendor?.toLowerCase() !== 'microsoft azure' &&
          d.vendor?.toLowerCase() !== 'google cloud platform' &&
          d.vendorName?.toLowerCase() !== 'amazon web services' &&
          d.vendorName?.toLowerCase() !== 'aws' &&
          d.vendorName?.toLowerCase() !== 'microsoft azure' &&
          d.vendorName?.toLowerCase() !== 'google cloud platform'
        );
      }

      setAssetsData(uniqueDevices);
    }
  }
  const clearAllFilters = () => {
    // setTypeData(clearData(typeData));
    setSearchTerm('');
    if (childRef.current) {
      childRef.current.triggerClear();
    }
    if (assetsTreeRef.current) {
      assetsTreeRef.current.triggerClear();
    }
    // updateAfterClear();
  }
  const resetFilter = () => {
    // Reset type data to initial state
    const resetData = _.cloneDeep(backUptypeData);
    // setTypeData(resetData);

    // Reset search term
    setSearchTerm('');

    // Reset asset data with initial filter state
    getAssetsData(_.cloneDeep(selectedFilterList(resetData)), resetData);

    // Reset tree state with backUptypeData
    if (childRef.current) {
      childRef.current.triggerReset(resetData);
    }
  }
  const getAllChildren = (node: any) => {
    return node.data?.selected ? node.data.flatMap(getAllChildren).concat(node.id) : [];
  };
  const finalFilterData = (data: any[] | undefined) => {
    data?.map(item => {
      if (('data' in item)) {
        delete item.parent;
        delete item.lavel;
        finalFilterData(item.data || []);
      } else {
        delete item.lavel;
        delete item.parent;
      }
    })
  }
  const saveFilterInfoCallback = (response: any) => {
    setIsLoader(false);
    toggleGlobalFilter(true);
    eventEmitter.emit('filterSaved', response);
  }

  const saveFilterDataCallback = (filterData: any, fullTreeData?: any) => {
    setIsLoader(false);
    toggleGlobalFilter(true);
    if (onFilterDataSaved) {
      onFilterDataSaved(filterData, fullTreeData);
    }
  }
  const saveFilterInfo = useCallback(async (req: any) => {
    setIsLoader(true);
    try {
      const response = await axiosInstance.post<any>(`${END_POINTS.SAVE_FILTER}`, req);
      saveFilterInfoCallback(response);
    } catch (error: any) {
          setIsLoader(false);

      toast.error(
        error.response.data
          ? error.response.data.message
          : "Something went wrong",
        { type: "error" }
      );
    }
  }, []);
  const saveFilter = () => {
    // Use filterTypeData if user interacted with checkboxes, otherwise fall back to typeData
    const dataForSave = filterTypeData.length > 0 ? filterTypeData : typeData;
    const selectedAssetsSet: any = new Set(selectedAssets);
    const checkAllSelected = (nodes: any[]): boolean => {
      return nodes.every((node) => {
        if (!node.selected) return false;
        if (node.data && node.data.length > 0) {
          return checkAllSelected(node.data);
        }
        return true;
      });
    };
    const isAllTypeSelected: boolean = checkAllSelected(dataForSave);
    const filteredDataForSave = selectedFilterList(_.cloneDeep(dataForSave));
    
    const allonprem: any = findNodeByType(filteredDataForSave, "onprem");
    const isallonpremselected= allonprem?.selected ? true : false;
    const AllselectedCloudNode: any = findNodeByType(filteredDataForSave, "cloud");
    const isAllCloudSelected:boolean=AllselectedCloudNode?.selected ? true : false;
    const isAllAssetsSelected: boolean = !!selectedAssetsSet && !!assetsData && assetsData.length > 0 && (selectedAssetsSet.size === assetsData.length);
    const filteredAssets = assetsData
      .filter((obj: any) => selectedAssetsSet.has(obj.id))
      .map((obj: any) => ({ ...obj, selected: true }));
    const request: any = {};
    const selectedRegion: any = findNodeByType(filteredDataForSave, "Region") || findNodeByType(filteredDataForSave, "Regions");
    const selectedVendors: any = findAllNodesByType(filteredDataForSave, "Vendors") || findAllNodesByType(filteredDataForSave, "Vendor");
    const selectedAssetInfo: any = findNodeByType(filteredDataForSave, "Asset Type") || findNodeByType(filteredDataForSave, "Asset Types");
    const selectedModelInfo: any = findNodeByType(filteredDataForSave, "Model") || findNodeByType(filteredDataForSave, "Models");
    const selectedAccountInfo: any = findNodeByType(filteredDataForSave, "Account") || findNodeByType(filteredDataForSave, "Accounts");
    const selectedResourceTypeInfo: any = findNodeByType(filteredDataForSave, "Resource Type") || findNodeByType(filteredDataForSave, "Resource Types");
    const selectedCloudRegionInfo: any = findNodeByType(filteredDataForSave, "Cloud Region") || findNodeByType(filteredDataForSave, "Cloud Regions");

    const regionState: any = findNodeByType(dataForSave, "Region") || findNodeByType(dataForSave, "Regions");
    const vendorsState: any = findAllNodesByType(dataForSave, "Vendors") || findAllNodesByType(dataForSave, "Vendor");
    const assetTypeState: any = findNodeByType(dataForSave, "Asset Type") || findNodeByType(dataForSave, "Asset Types");
    const modelState: any = findNodeByType(dataForSave, "Model") || findNodeByType(dataForSave, "Models");
    const accountState: any = findNodeByType(dataForSave, "Account") || findNodeByType(dataForSave, "Accounts");
    const resourceTypeState: any = findNodeByType(dataForSave, "Resource Type") || findNodeByType(dataForSave, "Resource Types");
    const cloudRegionState: any = findNodeByType(dataForSave, "Cloud Region") || findNodeByType(dataForSave, "Cloud Regions");

    const buildSection = (stateNode: any, prunedNode: any, allKey: string, listKey: string) => {
      if (stateNode?.selected && !stateNode?.indeterminate) {
        request[allKey] = true;
        request[listKey] = stateNode?.data || [];
      } else if (stateNode?.selected || stateNode?.indeterminate) {
        request[allKey] = false;
        request[listKey] = prunedNode?.data || [];
      } else {
        request[allKey] = false;
        request[listKey] = [];
      }
    };

    if (!isAllTypeSelected) {
      buildSection(regionState, selectedRegion, 'all_regions', 'regions_list');
      buildSection(vendorsState, selectedVendors, 'all_vendors', 'vendor_list');
      buildSection(assetTypeState, selectedAssetInfo, 'all_categories', 'category_list');
      buildSection(modelState, selectedModelInfo, 'all_models', 'model_list');
      buildSection(accountState, selectedAccountInfo, 'all_cloud_accounts', 'cloud_accounts_list');
      buildSection(resourceTypeState, selectedResourceTypeInfo, 'all_cloud_resource_types', 'cloud_resource_types_list');
      buildSection(cloudRegionState, selectedCloudRegionInfo, 'all_cloud_regions', 'cloud_regions_list');
    } else {
      request.all_regions = true;
      request.all_vendors = true;
      request.all_categories = true;
      request.all_models = true;
      request.all_cloud_accounts = true;
      request.all_cloud_resource_types = true;
      request.all_cloud_regions = true;
      request.regions_list = regionState?.data || [];
      request.vendor_list = vendorsState?.data || [];
      request.category_list = assetTypeState?.data || [];
      request.model_list = modelState?.data || [];
      request.cloud_accounts_list = accountState?.data || [];
      request.cloud_resource_types_list = resourceTypeState?.data || [];
      request.cloud_regions_list = cloudRegionState?.data || [];
    }
    // Always include the selected devices in devices_list, regardless of whether all are selected
    request.all_devices = isAllAssetsSelected;
    request.devices_list = filteredAssets;

    // Ensure devices_list contains the full asset objects, not just IDs
    if (isAllAssetsSelected && filteredAssets.length === 0) {
      // If all assets are selected but filteredAssets is empty, use all assetsData
      request.devices_list = assetsData.map((obj: any) => ({ ...obj, selected: true }));
    }
    let req: any = {};
    req.all_regions = request?.all_regions || false;
    req.all_vendors = request?.all_vendors || false;
    req.all_categories = request?.all_categories || false;
    req.all_models = request?.all_models || false;
    req.all_cloud_accounts = request?.all_cloud_accounts || false;
    req.all_cloud_resource_types = request?.all_cloud_resource_types || false;
    req.all_cloud_regions = request?.all_cloud_regions || false;
    const selectedCloudNode: any = findNodeByType(dataForSave, "cloud");
    req.all_cloud = selectedCloudNode?.selected ? true : false;
    const selectedOnPremNode: any = findNodeByType(dataForSave, "onprem");
    req.all_onprem = selectedOnPremNode?.selected ? true : false;
    finalFilterData(request?.regions_list);
    finalFilterData(request?.vendor_list);
    finalFilterData(request?.category_list);
    finalFilterData(request?.model_list);
    finalFilterData(request?.cloud_accounts_list);
    finalFilterData(request?.cloud_resource_types_list);
    finalFilterData(request?.cloud_regions_list);
    req.regions_list = request?.regions_list?.length ? request.regions_list : [];
    req.vendor_list = request?.vendor_list?.length ? _.map(request.vendor_list, 'id') : [];
    req.category_list = request?.category_list?.length ? _.map(request.category_list, 'id') : [];
    req.model_list = request?.model_list?.length ? _.map(request.model_list, 'id') : [];
    req.cloud_accounts_list = request?.cloud_accounts_list?.length ? _.map(request.cloud_accounts_list, 'id') : [];
    req.cloud_resource_types_list = request?.cloud_resource_types_list?.length ? _.map(request.cloud_resource_types_list, 'id') : [];
    req.cloud_regions_list = request?.cloud_regions_list?.length ? request.cloud_regions_list : [];
    req.all_devices = request?.all_devices || false;
    req.devices_list = request?.devices_list || [];

    console.log('=== SAVE FILTER DEBUG ===');
    console.log('filterTypeData:', JSON.parse(JSON.stringify(filterTypeData)));
    console.log('dataForSave (used):', JSON.parse(JSON.stringify(dataForSave)));
    console.log('isAllTypeSelected:', isAllTypeSelected);
    console.log('Save Filter Payload:', JSON.parse(JSON.stringify(req)));
    console.log('========================');

    // Check if we should skip API call and pass data through callback instead
    if (skipApiCall) {
      saveFilterDataCallback(req, dataForSave);
      clearAllFilters();
    } else {
      saveFilterInfo(req);
    }
  }

  useEffect(() => {
    if (filterTypeData.length === 0) return;
    setAssetsData([]);
    setAssetsLoader(false);
    setTypeData(_.cloneDeep(filterTypeData));
    getAssetsData(selectedFilterList(_.cloneDeep(filterTypeData)), filterTypeData);
  }, [filterTypeData]);
  useEffect(() => {
  }, [filterAssetsData]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false;
    //   return;
    // }
    getTypesData();
  }, []);

  return (
    <>
      <Toolbar sx={{ display: "flex", justifyContent: "right", pb: "10px", width: "100%", pr: "0 !important" }}>
        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
          Filters
        </Typography>
        <Box sx={{ display: "flex", alignItems: "right", pb: 0, pr: 0 }}>
          <Button
            onClick={clearAllFilters}
            variant="text"
            sx={{
              bgcolor: "none",
              color: "gray",
              height: "30px",
              fontSize: "12px",
              mr: "5px",
              "&:hover": { bgcolor: "rgba(0,0,0,0)", color: "gray" },
              "&:focus": { outline: "none" }
            }}
          >
            Clear
          </Button>
          <Button
            onClick={resetFilter}
            variant="text"
            sx={{
              bgcolor: "none",
              color: "gray",
              height: "30px",
              fontSize: "12px",
              mr: "5px",
              "&:hover": { bgcolor: "rgba(0,0,0,0)", color: "gray" },
              "&:focus": { outline: "none" }
            }}
          >
            Reset
          </Button>
          <Button
            onClick={saveFilter}
            disabled={
              assetsLoader ||
              typeLoader ||
              !assetsData.length ||
              !typeData.length ||
              selectedAssets?.size === 0

            }
            variant="contained"
            sx={{
              bgcolor: "primary",
              color: "white",
              textTransform: "none",
              height: "30px",
              fontSize: "12px",
              mr: "5px",
              "&:focus": { outline: "none" }
            }}
          >
            Apply
          </Button>
          <IconButton sx={{ mt: "-5px", "&:focus": { outline: "none" } }}>
            <CancelIcon onClick={toggleGlobalFilter} />
          </IconButton>
        </Box>
      </Toolbar>
      <Box sx={{ display: "flex", width: "100%", pb: 0, pr: '12px', pl: '12px' }}>
        <TextField
          fullWidth
          id="outlined"
          placeholder="Search Assets"
          onChange={(e) => setSearchTerm(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: '35px !important',
              border: 'none',
              borderRadius: '5px',
              //backgroundColor: '#f5f5f5',
              bgcolor: !isDarkMode ? "#EAEBF4" : "#1a202c'",

              boxShadow: '.5px .5px .5px .5px rgba(0, 0, 0, 0.1)',
              '& fieldset': {
                border: 'none',
              },
              '&:hover fieldset': {
                border: 'none',
              },
              '&.Mui-focused fieldset': {
                border: 'none', // Remove focus border
              },
            }
          }}
        />
      </Box>
      <Box sx={{ display: "flex", width: "100%", pb: 0, pr: '12px', pl: '12px' }}>
        <Box sx={{ display: "flex", width: "50%", pb: 0, pr: 0, pl: 1.5, height: "calc(100vh - 120px)", overflow: 'auto', overflowX: 'hidden' }}
          className="scroll">
          {typeLoader && (
            <SkeletonLoader count={15} styles={{ height: 20, width: '100%' }} />
          )}
          <Box sx={{ display: typeLoader ? 'none' : 'contents' }}>
            <Tree setFilterTypeData={setFilterTypeData} data={typeData} ref={childRef} getAssetsData={getAssetsData} />
          </Box>
        </Box>
        <Box sx={{ display: "flex", width: "50%", pb: 0, pr: 0, pl: 1.5 }}>
          {(assetsLoader || typeLoader) && (
            <SkeletonLoader count={20} styles={{ height: 15, width: '100%' }} />
          )}
          <Box sx={{ display: (assetsLoader || typeLoader) ? 'none' : 'contents' }}>
            <AssetsTree
              searchQuery={searchTerm}
              data={assetsData}
              setfilterAssetsData={setfilterAssetsData}
              setselectedAssets={setselectedAssets}
              ref={assetsTreeRef}
              getAssetsData={getAssetsData}
              filterTypeData={filterTypeData}
              preSelectedAssetIds={preSelectedAssetIds}
              clearFilters={clearFilters}
              skipApiCall={skipApiCall}
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default GlobalFilter;
